import axios from "axios";
import jwt_decode from "jwt-decode";
import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "universal-cookie";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "./AdminDashboard.css";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");
moment.tz.setDefault("America/Mexico_City");
let allDatesByRoom = null;

function Reservation({ session, setSession, userPicture, navigate }) {
  const CLIENT_ID = process.env.REACT_APP_CLIENT_ID_SALAS;
  const SCOPES = "https://www.googleapis.com/auth/calendar";
  const cookies = new Cookies();
  const localizer = momentLocalizer(moment);
  const [sala, setSala] = useState("");
  const [bgModalHeader, setBgModalHeader] = useState("");
  const modalReservacionRef = useRef(null);
  const modalReservacionInfoRef = useRef(null);
  const modalCalendarioRef = useRef(null);
  const [modalReservationView, setModalReservationView] = useState(false);
  const [modalReservationInfoView, setModalReservationInfoView] =
    useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [subject, setSubject] = useState("");
  const [guests, setGuests] = useState("");
  const [addedGuests, setAddedGuests] = useState([{ email: cookies.get("email") }]);
  const [events, setEvents] = useState([]);
  const [deleteEvent, setDeleteEvent] = useState(null);
  const [owner, setOwner] = useState("");
  const [reservationStatus, setReservationStatus] = useState(false);
  const [deleteReservationStatus, setDeleteReservationStatus] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isDirector, setIsDirector] = useState(false);
  const [isVideo, setIsVideo] = useState(false);
  const [isStaff, setIsStaff] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);

  
  useEffect(() => {
    loadUsers();
  }, []);

  useEffect(() => {
    allDatesByRoom = events;
  }, [events]);

  // ********************************* Deteccion de Sala actual *********************************
  /* The above code is using the `useEffect` hook in a React component to load all reservations for a
given `sala` (room) and log the current `sala` to the console. The `useEffect` hook is triggered
whenever the `sala` variable changes. The `loadAllReservations` function is likely an asynchronous
function that fetches reservation data from an API or database. The `eslint-disable-next-line`
comment is used to disable a specific linting rule for this line of code. */
  useEffect(() => {
    const fetchReservations = async () => {
      // await loadAllReservations();
      if(sala !== ""){
        console.info("Sala actual: ", sala);
        if (sala === "Sala VIP") {
          setBgModalHeader("bg-salaVip");
        } else if (sala === "Ejecutiva") {
          setBgModalHeader("bg-salaEjecutiva");
        } else if (sala === "Editorial") {
          setBgModalHeader("bg-salaEditorial");
        } else if (sala === "Estudio de Podcast") {
          setBgModalHeader("bg-salaPodcast");
        } else if (sala === "Estudio") {
          setBgModalHeader("bg-salaVideo");
        } else if (sala === "Presidencia") {
          setBgModalHeader("bg-salaPresidencia");
        }
      }
    };
    fetchReservations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sala]);
  // ********************************* Seteo de eventos en el calendario *********************************
  /**
   * The function adds a new event to an array of events and updates the events.
   * @param data - The `data` parameter is a variable that contains information about a calendar event
   * that needs to be added to an array of events.
   */
  function setCalendarEvents(data) {
    var arr = events;
    arr.push(data);
    setEvents(arr);
  }

  function deleteCalendarEvent() {
    const idx = events.indexOf(deleteEvent);
    events.splice(idx, 1);
    setEvents(events);
  }
  // ********************************* Deteccion del status de la reservacion realizada  *********************************
  /* The above code is a React useEffect hook that listens for changes in the `reservationStatus` state
variable. If the `reservationStatus` is true, it logs a message to the console, hides a modal,
clears a form, shows a success toast message, removes some items from the local storage, and sets
the `reservationStatus` to false. This code is likely part of a larger React component that handles
reservations for an event or activity. */
  useEffect(() => {
    if (reservationStatus === true) {
      console.info("Estado de reservacion success");
      modalAction("hide", modalReservacionRef.current);
      setTimeout(() => {
        cleanForm();
      }, 1000);
      showToast("success", "Reservación realizada");
      toast.clearWaitingQueue();
      window.localStorage.removeItem("evento");
      window.localStorage.removeItem("data");
      setSala(sala);
      setReservationStatus(false);
    }
  }, [reservationStatus]);
  // ********************************* Deteccion del status de la reservacion eliminada  *********************************
  /* The below code is a React useEffect hook that listens for changes in the `deleteReservationStatus` state
variable. If the `deleteReservationStatus` is true, it logs a message to the console, hides a modal,
clears a form, shows a success toast message, removes some items from the local storage, and sets
the `deleteReservationStatus` to false. This code is likely part of a larger React component that handles delete of
reservations for an event or activity. */
  useEffect(() => {
    if (deleteReservationStatus === true) {
      console.info("Estado de eliminacion de reservacion success");
      modalAction("hide", modalReservacionInfoRef.current);
      setTimeout(() => {
        cleanForm();
      }, 1000);
      showToast("success", "Reservación eliminada");
      toast.clearWaitingQueue();
      window.localStorage.removeItem("evento");
      window.localStorage.removeItem("data");
      console.log("Reiniciando sala");
      setSala(sala);
      setDeleteReservationStatus(false);
    }
  }, [deleteReservationStatus]);
  // ********************************* Configuracion de fecha por default en el calendario *********************************
  /* The above code is using the `useMemo` hook in React to create a memoized object with a `defaultDate`
property. The `defaultDate` property is set to a new `Date` object with the current year, month, and
day. The `useMemo` hook is used to optimize performance by only recomputing the object when its
dependencies change. In this case, there are no dependencies, so the object is only computed once. */
  const { defaultDate } = useMemo(
    () => ({
      defaultDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
    }),
    []
  );
  // *********************************  Inicio ,  generar token de acceso y autentificacion para google calendar // *********************************
  /* The above code is using the Google OAuth2 API to obtain an access token for the user. Once the
access token is obtained, it is stored in the user's local storage. Then, a POST request is made to
the Google Calendar API to create a new event in the user's primary calendar. The request includes
the access token in the Authorization header and the event details in the request body. If the
request is successful, the function `saveReservationDb()` is called to save the reservation in a
database. */
  const clients = window.google.accounts.oauth2.initTokenClient({
    client_id: CLIENT_ID,
    scope: SCOPES,
    callback: (tokenResponse) => {
      console.info("Token de acceso a Google Client: ", tokenResponse);
      window.localStorage.setItem("token", tokenResponse.access_token);
      if (tokenResponse && tokenResponse.access_token) {
        // Este callback se ejecuta tras obtener el token. Para entonces la
        // reservación YA fue validada y guardada en la BD (ver saveReservationDb).
        // Por eso aquí solo se crea el evento en Google Calendar: si la sala
        // estuviera ocupada, nunca se llega hasta aquí.
        fetch(
          "https://www.googleapis.com/calendar/v3/calendars/primary/events?sendUpdates=all",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${window.localStorage.getItem("token")}`,
            },
            body: window.localStorage.getItem("evento"),
          }
        )
          .then((response) => response.json())
          .then((json) => {
            console.info("Evento creado en Google Calendar:", json && json.id);
            setReservationStatus(true);
          })
          .catch((err) => console.log(err));
      }
    },
    prompt: "",
  });
  // *********************************  Se cargan todas las reservaciones de la BD // *********************************
  /**
 * The function loads reservations from a database and filters them based on the selected room.
 * Returns an array of objects with status success
 * {
    "status": "success",
    "reservaciones": [
        {
            "_id": "648393118c85658a7d9527d1",
            "asunto": "prueba 10 a 11",
            "fechaHoraInicio": "2023-06-09T10:00:00.000",
            "fechaHoraFin": "2023-06-09T11:00:00.000",
            "invitados": "daniel.montalvo@mmkgroup.com.mx",
            "sala": "Sala VIP",
            "__v": 0
        }
 */

  function addGuest(event) {
    if(event.key === " " || event.target.dataset.action === "Button"){
      if (guests.includes("@")) {
        const existeEmail = addedGuests.some((informacion) => {
          return informacion.email.trim() === guests.trim();
        })
        if(!existeEmail){
          setAddedGuests((prevEmail) => [...prevEmail, { email: guests}]);
          setGuests("");
        }
      } else {
        return false;
      }
    }
  }


  function deleteEmail(e){
    const updateAddedGuests = addedGuests.filter((guest) => {
      return guest.email !== e.target.dataset.email;
    })
    setAddedGuests(updateAddedGuests);
  }

  function loadUsers() {
    var ahora = new Date();
    var milisegundos = ahora.getMilliseconds();
    axios({
      url: process.env.REACT_APP_HOST + `/api/usuarios/?v=${milisegundos}`,
      method: "GET",
    })
      .then(function (response) {
        if (response.data.status) {
          console.log("info usuarios: ", response.data);
          getCurrentUser(response.data.body.users.Items);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  function getCurrentUser(data) {
    for (let i = 0; i < data.length; i++) {
      if (cookies.get("email") === data[i].email.S) {
        if (data[i].role.S === "admin") {
          setIsAdmin(true);
        }
        if (data[i].role.S === "director") {
          setIsDirector(true);
        }
        if (data[i].role.S === "video") {
          setIsVideo(true);
        }
        if (data[i].role.S === "staff") {
          setIsStaff(true);
        }
      }
    }
  }
  function loadAllReservations(startDate= "", endDate= "", room = sala) {
    return new Promise((resolve, reject) => {
      var ahora = new Date();
      var milisegundos = ahora.getMilliseconds();
      let dynamicUrl = "";

      if(startDate !== "" && endDate !== ""){
        dynamicUrl = `/api/reservaciones/semana?fecha_inicio=${startDate}&fecha_fin=${endDate}`;
      }else{
        dynamicUrl = `/api/reservaciones/semana`;
      }

      axios({
        url: process.env.REACT_APP_HOST + dynamicUrl,
        method: "GET",
      })
        .then(function (response) {
          console.info("Reservas obtenidas: ", response);
          if (response.data.body.reservaciones.Items.length > 0) {
            console.info(
              "Carga de reservaciones de la BD: ",
              response.data.body.reservaciones.Items
            );
            let reservacionesList = response.data.body.reservaciones.Items;
            // Cambia sala por room en los filtros
            if (response.data.status === "success" && room === "Sala VIP") {
              filterReservations(reservacionesList, room);
            }

            if (response.data.status === "success" && room === "Sala Ejecutiva Comercial") {
              filterReservations(reservacionesList, room);
            }

            if (response.data.status === "success" && room === "Editorial") {
              filterReservations(reservacionesList, room);
            }
            if (
              response.data.status === "success" &&
              room === "Estudio de Podcast"
            ) {
              filterReservations(reservacionesList, room);
            }
            if (response.data.status === "success" && room === "Hall") {
              filterReservations(reservacionesList, room);
            }
            if (response.data.status === "success" && room === "Estudio") {
              filterReservations(reservacionesList, room);
            }
            if (response.data.status === "success" && room === "Presidencia") {
              filterReservations(reservacionesList, room);
            }
          } 
          resolve();
        })
        .catch(function (error) {
          console.log("Error al obtener las reservaciones");
          console.log(error);
          reject(error);
        });
    });
  }
  // *********************************  Se filtran las reservaciones de la BD // *********************************
  /**
   * The function filters reservations by room and date, transforms the date format, and sets the events
   * for a calendar.
   * @param response - The response object containing the data to be filtered and transformed into events
   * for the calendar.
   * @param sala - `sala` is a variable representing the room or space being filtered for reservations.
   * The function `filterReservations` takes in a response object and a `sala` parameter, and filters the
   * reservations in the response object to only include those for the specified room.
   */
  function filterReservations(response, sala) {
    let dataByRoom = null;
    let currentDate = new Date();
    // const fechaUnMesAtras = new Date();
    // fechaUnMesAtras.setMonth(fechaUnMesAtras.getMonth() -1)
    currentDate.setHours(0, 0, 0);

    var data = response; //response.data.reservaciones;
    console.log("Datos a filtrar: ", data);
    /*dataByRoom = data.filter(
      (value) =>
        value.sala.S === sala &&
        new Date(value.fechaHoraInicio.S) >= currentDate
	);*/

    dataByRoom = data.filter((value) => value.sala.S === sala  );
    // dataByRoom = data.filter((value) => value.sala.S === sala && new Date(value.fechaHoraInicio.S) >= fechaUnMesAtras );

    console.info("Datos filtrados por sala: ", dataByRoom);
    //Se transforma la fecha inicial y final  para el formato del calendario y poder setear
    setEvents([]);
    var arr = [];
    for (let i = 0; i < dataByRoom.length; i++) {
      arr.push({
        start: moment.tz(dataByRoom[i].fechaHoraInicio.S, "America/Mexico_City").toDate(),
        end: moment.tz(dataByRoom[i].fechaHoraFin.S, "America/Mexico_City").toDate(),
        title: dataByRoom[i].asunto.S,
        sala: dataByRoom[i].sala.S,
        id: dataByRoom[i].reservacionId.S,
      });
    }
    setEvents(arr);
  }
  // ********************************* Evento en el click y drag del slot del calendario // *********************************
  /* The above code is defining a function called `handleSelectSlot` using the `useCallback` hook. This
function takes an object with `start`, `end`, and `slots` properties as its argument. It first
checks if the selected date is in the past, and if so, it logs a message and returns null. If the
selected date is not in the past, it calls a function called `checkIfDateIsAvailable` with the
`start`, `end`, and `events` arguments. If this function returns true, it logs a message and returns
null. If the function returns */
  const handleSelectSlot = useCallback(({ start, end, slots }) => {
    //Se determina si la fecha seleccionada es de dias pasados
    if (moment(start).isBefore(moment(), "day") === true) {
      console.info("No se puede seleccionar una fecha atrasada");
      return null;
    } else {
      let resp = checkIfDateIsAvailable(start, end, allDatesByRoom);
      if (resp === true) {
        console.info(
          "No se puede seleccionar este rango de fecha. Abriendo modal de información de evento"
        );
        return null;
      } else {
        console.log("Fecha valida para asignar");
        setModalReservationView(true);
        modalAction("show", modalReservacionRef.current);
        detectCloseModal(modalReservacionRef.current);
        setStartDate(moment(start).format("YYYY-MM-DDTHH:mm:ss.SSS"));
        setEndDate(moment(end).format("YYYY-MM-DDTHH:mm:ss.SSS"));
        setOwner(cookies.get("email"));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ********************************* Informacion del evento // *********************************
  /* The above code is defining a function called `handleEvent` using the `useCallback` hook. This
function will display the information of the clicked event. If the owner is the one visualizing the information it can be possible to delete de event */
  const handleEvent = useCallback((event) => {
    //Se obtienen los datos del evento y se muestran en un modal
    console.log(event);
    setModalReservationInfoView(true);
    modalAction("show", modalReservacionInfoRef.current);
    detectCloseModal(modalReservacionInfoRef.current);
    setStartDate(moment(event.start).format("YYYY-MM-DDTHH:mm:ss.SSS"));
    setEndDate(moment(event.end).format("YYYY-MM-DDTHH:mm:ss.SSS"));
    setOwner(event.id.split("-")[0]);
    setSubject(event.title);
    setDeleteEvent(event);
    //alert(JSON.stringify(event));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ********************************* Funcion que verifica si la fecha esta disponible para seleccionar // *********************************
  /**
   * The function checks if a given date range is available by comparing it with existing reservations.
   * @param startDate - The start date of the new reservation to check availability for.
   * @param endDate - The endDate parameter is a date representing the end date of a reservation period.
   * @param reservations - an array of objects representing existing reservations. Each object has two
   * properties: "start" and "end", which are strings representing the start and end dates of the
   * reservation in the format "YYYY-MM-DD".
   * @returns a boolean value indicating whether the given date range (startDate to endDate) is available
   * or not based on the reservations array provided. If the reservations array is empty, the function
   * returns undefined.
   */
  function checkIfDateIsAvailable(startDate, endDate, reservations) {
    console.info("reservaciones a checar: ", reservations);
    var resp = false;
    if (reservations.length !== 0) {
      for (let i = 0; i < reservations.length; i++) {
        if (new Date(startDate) >= new Date(reservations[i].start)) {
          if (new Date(startDate) < new Date(reservations[i].end)) {
            resp = true;
            break;
          }
        } else {
          if (new Date(endDate) > new Date(reservations[i].start)) {
            resp = true;
            break;
          }
        }
      }
      return resp;
    }
  }

  // ********************************* Funcion para abrir y cerrar los modales // *********************************
  /**
   * This is a JavaScript function that shows or hides a Bootstrap modal based on the action parameter.
   * @param action - The action parameter is a string that specifies whether to show or hide a modal. If
   * the value of action is "show", the function will show the modal with the specified id. If the value
   * of action is anything else, the function will hide the modal with the specified id.
   * @param idModal - idModal is a string parameter that represents the ID of the modal element that
   * needs to be shown or hidden. It is used to identify the specific modal element that needs to be
   * opened or closed.
   */
  const modalAction = (action, idModal) => {
    if (action === "show") {
      console.info("mostrando modal: ", idModal);
      let modalVariantOpen = new bootstrap.Modal(idModal);
      modalVariantOpen.show();
    } else {
      console.info("Cerrando modal: ", idModal);
      var modalVariantClose = bootstrap.Modal.getInstance(idModal);
      modalVariantClose.hide();
      let backdropModal = document.getElementsByClassName("modal-backdrop");
      backdropModal[0].remove();
    }
  };
  // ********************************* Funcion para limpiar formulario // *********************************
  /**
   * The function cleans the data of a reservation form.
   */
  function cleanForm() {
    console.info("Limpiando Datos de reservación");
    setSubject("");
    setStartDate(null);
    setEndDate(null);
    setGuests("");
  }
  // ********************************* Funcion para detectar el cierre del modal // *********************************
  /**
   * This function detects the closing of a modal and sets a state variable to false.
   * @param idModal - The idModal parameter is a reference to the modal element that the function is
   * listening for the "hidden.bs.modal" event on. This event is triggered when the modal is closed or
   * hidden from view.
   */
  const detectCloseModal = (idModal) => {
    // Evento para detectar el cierre del modal
    idModal.addEventListener("hidden.bs.modal", function (event) {
      console.info("cerrando modal: ", idModal);
      setModalReservationView(false);
    });
  };
  // ********************************* Funcion para hacer la reservacion // *********************************
  /**
   * The function creates a reservation object with start and end dates, a title, and a room, adds it to
   * a calendar, and logs the reservation information.
   */
  const reserve = () => {
    var reservacion = {
      id: cookies.get("email") + "-" + moment.tz(startDate, "America/Mexico_City").valueOf(),
      start: moment.tz(startDate, "America/Mexico_City").toDate(),
      end: moment.tz(endDate, "America/Mexico_City").toDate(),
      title: subject,
      sala: sala,
    };
    setCalendarEvents(reservacion);
    console.log("Asignando evento a react calendar", reservacion);
    setEventInGoogle();
  };
  // ********************************* Funcion que detecta el cambio de los inputs  // *********************************
  /**
   * The function watches for changes in the input fields for subject and guests and updates their values
   * accordingly.
   * @param e - The parameter "e" is an event object that is passed to the function "watchInput" when an
   * event (such as a user typing in an input field) occurs. It contains information about the event,
   * such as the target element that triggered the event and the value of the input field.
   */
  function watchInput(e) {
    if (e.target.id === "subjectInput") {
      setSubject(e.target.value);
    }
    if (e.target.id === "guestInput") {
      setGuests(e.target.value);
    }
  }
  // ********************************* Funcion para mostrar las variantes de toastify // *********************************
  /**
   * The function showToast displays a toast message with a specified type and message.
   * @param typeToast - A string that specifies the type of toast to display. It can be "success",
   * "danger", "warning", or any other string for an info toast.
   * @param message - The message to be displayed in the toast notification.
   */
  function showToast(typeToast, message) {
    let varToast;
    switch (typeToast) {
      case "success":
        varToast = toast.success;
        break;
      case "danger":
        varToast = toast.danger;
        break;
      case "warning":
        varToast = toast.warning;
        break;
      default:
        varToast = toast.info;
    }
    varToast(message, {
      position: "top-center",
      autoClose: 8000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  // ********************************* Funcion que asigna la sala seleccionada // *********************************
  /**
   * The function loads a room and displays a calendar modal after a short delay.
   * @param room - The `room` parameter is a variable that represents the room that needs to be loaded.
   * It is used in the `loadRoom` function to check if the current room is different from the one that
   * needs to be loaded. If they are different, the function sets the new room and then shows a
   */
async function loadRoom(room) {
  console.info("Asignando sala: ", room);
  setSala(room);
  // Calcula las fechas de la semana actual
  const startOfWeek = moment().startOf('week').format('YYYY-MM-DD');
  const endOfWeek = moment().endOf('week').format('YYYY-MM-DD');
  // Pasa room como argumento
  await loadAllReservations(startOfWeek, endOfWeek, room);
  setTimeout(() => {
    modalAction("show", modalCalendarioRef.current);
  }, 350);
}
  // ********************************* Funcion que asigna el evento a google calendar // *********************************
  /**
   * The function sets up a Google calendar event with details such as the event name, location, start
   * and end time, attendees, and reminders.
   */
  function setEventInGoogle() {
    // NOTA: ya NO se llama aquí a clients.requestAccessToken().
    // El flujo correcto es: 1) guardar/validar en la BD (saveReservationDb),
    // 2) solo si la BD aprueba, crear el evento en Google Calendar.
    // Esta función únicamente prepara y guarda en localStorage el evento y la data.

    // Se actualizar organizador para que se le envie el correo de notificacion de la creacion del evento
    const invitados = addedGuests.map(user => {
      if(user.email ===  cookies.get("email")){
        let splitEmail = user.email.split("@");
        return { ...user, email: splitEmail[0] + '+1@' +splitEmail[1] }
      }else{
        return user;
      }
    });

    let evento = {
      summary: "Reservación " + sala + " ," + subject,
      location:
        "Alejandro Dumas 243, Polanco, Polanco IV Secc, Miguel Hidalgo, 11550 Ciudad de México, CDMX",
      description: subject,
      start: {
        dateTime: startDate,
        timeZone: "America/Mexico_City",
      },
      end: {
        dateTime: endDate,
        timeZone: "America/Mexico_City",
      },
      recurrence: ["RRULE:FREQ=DAILY;COUNT=1"],
      attendees: invitados,
      reminders: {
        useDefault: true,
      },
      sendUpdates: "all",
    };
    console.info("Datos a almacenar en Local: ", evento);
    window.localStorage.setItem("evento", JSON.stringify(evento));
    console.log("se almacena en localStorage el evento", evento);
    let array_guest = guests.split(",");
    let verified_guests = [];
    var emailRegex =
      /(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gm;
    array_guest.forEach((element) => {
      if (element.match(emailRegex)) verified_guests.push(element);
    });

    let data = {
      id: cookies.get("email") + "-" + startDate,
      asunto: subject,
      fechaHoraInicio: startDate,
      fechaHoraFin: endDate,
      invitados:
        verified_guests.length <= 0
          ? cookies.get("email")
          : verified_guests.toString(),
      sala: sala,
    };
    console.log("data del google calendar", data);
    window.localStorage.setItem("data", JSON.stringify(data));

    // Paso 1: validar y guardar en la BD. Solo si la BD aprueba (sin traslape)
    // se creará el evento en Google Calendar (dentro de saveReservationDb).
    saveReservationDb();
  }
  // Verifica si el id_token de Google ya expiró antes de hacer peticiones.
  function isTokenExpired() {
    const token = cookies.get("id_token");
    if (!token) return true;
    try {
      const decoded = jwt_decode(token);
      return decoded.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  }

  // ********************************* Funcion para guardar la reservacion en la bd // *********************************
  /**
   * The function saves reservation data to a database using an HTTP POST request.
   */
  function saveReservationDb() {
    if (isTokenExpired()) {
      showToast("warning", "Tu sesión expiró. Por favor inicia sesión de nuevo.");
      setTimeout(() => setSession(false), 2500);
      return;
    }

    let data = JSON.parse(window.localStorage.getItem("data"));
    data["reservacionId"] =
      cookies.get("email") + "-" + data["fechaHoraInicio"];
    // Se guarda en bd datos de reservacion (ANTES de crear el evento en Google)
    console.info("Se busca guardar en la BD el evento");
    axios
      .request({
        url: process.env.REACT_APP_HOST + "/api/save",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${cookies.get("id_token")}`,
        },
        data: data,
      })
      .then(function (response) {
        console.info("Respuesta de guardado en la BD ", response);
        if (response.data.status === "success") {
          console.log("Reservacion guardada en la BD: ", data);
          // Paso 2: la BD aprobó (sin traslape) -> ahora sí se crea el evento
          // en Google Calendar. El token dispara el callback que lo crea.
          clients.requestAccessToken();
        }
      })
      .catch(function (error) {
        // El backend responde 409 cuando la sala ya está reservada en ese horario
        // (traslape detectado en el servidor). Como la BD se valida ANTES de crear
        // el evento en Google, aquí NO hay nada que borrar en Google Calendar.
        if (error.response && error.response.status === 409) {
          console.warn("Reservación rechazada por traslape:", error.response.data);
          showToast(
            "warning",
            "La sala ya fue reservada en ese horario. Actualiza el calendario e intenta de nuevo."
          );
          modalAction("hide", modalReservacionRef.current);
          setTimeout(() => {
            cleanForm();
          }, 500);
          loadAllReservations();
        } else if (error.response && error.response.status === 400) {
          showToast("warning", "Datos de la reservación incompletos o inválidos.");
        } else if (error.response && error.response.status === 401) {
          showToast("warning", "Tu sesión expiró. Por favor inicia sesión de nuevo.");
          setTimeout(() => setSession(false), 2500);
        } else {
          console.log(error);
          showToast("warning", "Ocurrió un error al guardar la reservación.");
        }
      });
  }
  // ********************************* Funcion para eliminar la reservacion en la bd // *********************************
  /**
   * The function deletes reservation from database using an HTTP DELETE request.
   */
  function deleteReservationDb() {
    let reservacionId = cookies.get("email") + "-" + startDate;
    let data = {
      reservacionId: reservacionId,
    };
    // Se guarda en bd datos de reservacion
    axios
      .request({
        url: process.env.REACT_APP_HOST + "/api/reservaciones",
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        data: data,
      })
      .then(function (response) {
        console.info("Respuesta de eliminación en la BD ", response);
        if (response.data.status === "success") {
          setDeleteReservationStatus(true);
          console.log("Reservacion eliminada de la BD");
          deleteCalendarEvent();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  // ********************************* Funcion que muestra los datos completos del evento en el calendario // *********************************
  // const handleSelectEvent = useCallback((event) => {
  //   console.log(event);
  //   window.alert(event.title);
  // }, []);

  // ********************************* Evento de navegación del calendario (next, back, hoy, cambio de vista) *********************************
  const handleNavigate = (date, view, action) => {
    if (action === "NEXT" || action === "PREV" || action === "TODAY") {
      if (isNavigating) return; // Evita doble click rápido
      setIsNavigating(true);
      const startOfWeek = moment(date).startOf('week').format('YYYY-MM-DD');
      const endOfWeek = moment(date).endOf('week').format('YYYY-MM-DD');
      loadAllReservations(startOfWeek, endOfWeek, sala)
        .finally(() => setIsNavigating(false));
    }
  };

  return (
    <>
      <ToastContainer limit={1} id="customToast" />
      <style>
        {`
          .rbc-toolbar button:disabled,
          .rbc-toolbar button.disabled {
            pointer-events: none;
            opacity: 0.5;
          }
        `}
      </style>
      <div className="profile">
        <div className="sesion">
          {session && (
            <div className="row text-black w-100 m-0 d-flex flex-column align-content-end">
              <div className="col-12 col-sm-6 text-center p-0 mt-0">
                <img
                  className="imgProfile mt-2"
                  src={userPicture}
                  alt="perfil"
                  referrerPolicy="no-referrer"
                />
                {/* <small className="d-block text-white pt-1">Bienvenido:</small>
                <small className="d-block text-white pt-0">
                  {cookies.get("given_name")}
                </small> */}
              </div>
              <div className="col-12 col-sm-6 text-center p-0 d-flex align-items-center justify-content-center mt-0">
                <button
                  className="btn btn-sm btn-primary py-1 mt-1 md-mt-4 px-2 btnCloseSession"
                  onClick={() => {
                    setSession(false);
                  }}
                >
                  Cerrar Sesión
                </button>
              </div>
            </div>
          )}
        </div>
        {/* inicio modal calendario  */}
        <div
          className="modal fade"
          tabIndex="-1"
          id="calendarModal"
          aria-labelledby="calendarModal"
          aria-hidden="true"
          ref={modalCalendarioRef}
          style={
            modalReservationView
              ? { visibility: "hidden" }
              : { visibility: "visible" }
          }
        >
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content">
              <div className={"modal-header text-white " + bgModalHeader}>
                <h5 className="modal-title">{sala}</h5>
                <button
                  type="button"
                  className="btn-close bg-light"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <Calendar
                  defaultDate={defaultDate}
                  defaultView={"week"}
                  views={["week", "agenda"]}
                  events={events}
                  localizer={localizer}
                  onSelectEvent={handleEvent}
                  onSelectSlot={handleSelectSlot}
                  selectable
                  // start time 8:00am
                  min={
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      new Date().getDate(),
                      7
                    )
                  }
                  // end time 6:00pm
                  max={
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      new Date().getDate(),
                      23
                    )
                  }
                  style={{ width: "100%", height: "500px" }}
                  onNavigate={handleNavigate}
                  toolbar={true}
                  components={{
                    toolbar: (props) => (
                      <div className="rbc-toolbar">
                        <span className="rbc-btn-group">
                          <button
                            type="button"
                            className={`rbc-btn rbc-btn-prev${isNavigating ? " disabled" : ""}`}
                            onClick={() => !isNavigating && props.onNavigate('PREV')}
                            disabled={isNavigating}
                          >
                            ‹
                          </button>
                          <button
                            type="button"
                            className={`rbc-btn rbc-btn-today${isNavigating ? " disabled" : ""}`}
                            onClick={() => !isNavigating && props.onNavigate('TODAY')}
                            disabled={isNavigating}
                          >
                            Hoy
                          </button>
                          <button
                            type="button"
                            className={`rbc-btn rbc-btn-next${isNavigating ? " disabled" : ""}`}
                            onClick={() => !isNavigating && props.onNavigate('NEXT')}
                            disabled={isNavigating}
                          >
                            ›
                          </button>
                        </span>
                        <span className="rbc-toolbar-label">{props.label}</span>
                        <span className="rbc-btn-group">
                          {props.views.map((view) => (
                            <button
                              type="button"
                              key={view}
                              className={`rbc-btn${props.view === view ? " rbc-active" : ""}`}
                              onClick={() => props.onView(view)}
                            >
                              {view.charAt(0).toUpperCase() + view.slice(1)}
                            </button>
                          ))}
                        </span>
                      </div>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* fin modal calendario  */}
        {/* inicio modal reservacion  */}
        <div
          className="modal fade"
          id="modalReservacion"
          ref={modalReservacionRef}
          tabIndex="-1"
          aria-labelledby="modalReservacion"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className={"modal-header text-white " + bgModalHeader}>
                <h5 className="modal-title px-5 text-center">
                  Agrega el asunto de tu reunion y tus invitados
                </h5>
                <button
                  type="button"
                  className="btn-close bg-light"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body py-5">
                <label htmlFor="subjectInput">Asunto</label>
                <input
                  id="subjectInput"
                  type="text"
                  className="form-control mb-4"
                  aria-label="asunto"
                  aria-describedby="basic-addon1"
                  onChange={watchInput}
                  value={subject}
                />
                <label htmlFor="startInput">Hora inicio</label>
                <input
                  id="startInput"
                  className="form-control mb-4"
                  type="text"
                  value={moment(startDate).format("MMMM Do YYYY, h:mm:ss a")}
                  readOnly
                />
                <label htmlFor="endInput">Hora fin</label>
                <input
                  id="endInput"
                  className="form-control mb-4"
                  type="text"
                  value={moment(endDate).format("MMMM Do YYYY, h:mm:ss a")}
                  readOnly
                ></input>
                <label htmlFor="guestInput">Invitados (opcional)</label>
                <div className="input-group mb-3">
                  <input
                    id="guestInput"
                    type="text"
                    className="form-control"
                    placeholder="Invitados"
                    aria-label="Invitados"
                    aria-describedby="button-addonGuest"
                    onChange={watchInput}
                    value={guests}
                    onKeyDown={addGuest}
                  />
                  <button
                    data-action="Button"
                    onClick={addGuest}
                    className="btn btn-primary"
                    type="button"
                    id="button-addonGuest"
                  >
                    Agregar
                  </button>
                </div>
                {/* Invitados agregados */}
                {addedGuests.length > 0 &&
                  addedGuests.map((guestEmail, index) => {
                    return (
                      guestEmail.email !==  cookies.get("email") &&
                      <span
                        key={index}
                        className="badge bg-body-tertiary text-dark  px-4 py-2 shadow-sm m-2 position-relative text-muted"
                      >
                        {guestEmail.email}
                        <button
                          data-email={guestEmail.email}
                          onClick={deleteEmail}
                          type="button"
                          className="btn-close  position-absolute top-0 border border-light"
                          style={{ right: "-7px" }}
                          aria-label="Close"
                        ></button>
                      </span>
                    );
                  })}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={reserve}
                  disabled={
                    startDate !== null && endDate !== null && subject !== ""
                      ? false
                      : true
                  }
                >
                  Reservar
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* fin modal reservacion  */}
        {/* inicio modal informacion de reservacion  */}
        <div
          className="modal fade"
          id="modalReservacion"
          ref={modalReservacionInfoRef}
          tabIndex="-1"
          aria-labelledby="modalReservacionInfo"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className={"modal-header text-white " + bgModalHeader}>
                <h5 className="modal-title px-5 text-center">{subject}</h5>
                <button
                  type="button"
                  className="btn-close bg-light"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body py-5">
                <h6>Reservado por: {owner}</h6>
                <p>
                  Hora inicio:{" "}
                  {moment(startDate).format("MMMM Do YYYY, h:mm:ss a")}
                </p>
                <p>
                  Hora fin: {moment(endDate).format("MMMM Do YYYY, h:mm:ss a")}
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                {owner === cookies.get("email") && (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={deleteReservationDb}
                  >
                    Eliminar evento
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* fin modal informacion de reservacion  */}
        <div className="rooms">
          <div className="container-fluid px-0">
            <div className="row">
              <div className="sidebarRooms">
                <div className="sideBar">
                  {/* <h1 className="text-white textTitle">Salas</h1> */}
                  {isAdmin && (
                    <button
                      className="admin-access-btn"
                      onClick={() => navigate && navigate("/admin")}
                    >
                      <span className="gear">⚙</span>
                      Panel de administración
                    </button>
                  )}

                  <div className="containerRooms">
                    <h5
                      id="VIP"
                      className="text-white d-inline text-uppercase"
                      onClick={() => loadRoom("Sala VIP")}
                    >
                      SALA VIP
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ms-2" style={{verticalAlign:"middle",opacity:0.85}}>
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                    </h5>

                    <h5
                      id="Ejecutiva"
                      className="text-white d-inline text-uppercase"
                      onClick={() => loadRoom("Sala Ejecutiva Comercial")}
                    >
                      SALA EJECUTIVA COMERCIAL
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ms-2" style={{verticalAlign:"middle",opacity:0.85}}>
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                    </h5>
                    
                    <h5
                      className="text-white d-inline text-uppercase"
                      onClick={() => loadRoom("Editorial")}
                    >
                      EDITORIAL
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ms-2" style={{verticalAlign:"middle",opacity:0.85}}>
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                    </h5>
                    <h5
                      className="text-white d-inline text-uppercase"
                      value={"Estudio de Podcast"}
                      onClick={() => loadRoom("Estudio de Podcast")}
                    >
                      Estudio de Podcast
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ms-2" style={{verticalAlign:"middle",opacity:0.85}}>
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                    </h5>
                    <h5
                      className="text-white d-inline text-uppercase"
                      value={"Hall"}
                      onClick={() => loadRoom("Hall")}
                    >
                      Hall
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ms-2" style={{verticalAlign:"middle",opacity:0.85}}>
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                    </h5>
                    <h5
                      className="text-white d-inline text-uppercase"
                      value={"Estudio"}
                      onClick={() => loadRoom("Estudio")}
                    >
                      Estudio
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ms-2" style={{verticalAlign:"middle",opacity:0.85}}>
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                    </h5>
                    <h5
                      className="text-white d-inline text-uppercase"
                      value={"Presidencia"}
                      onClick={() => loadRoom("Presidencia")}
                    >
                      Presidencia
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ms-2" style={{verticalAlign:"middle",opacity:0.85}}>
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                    </h5>
                  </div>
                </div>
              </div>
              {/* incio seleccion de salas*/}
              {sala === "Sala VIP" ? (
                <div key="bgVip" className="bgVip"></div>
              ) : sala === "Editorial" ? (
                <div key="bgEditorial" className="bgEditorial"></div>
              ) : sala === "Sala Ejecutiva Comercial" ? (
                <div key="bgEjecutiva" className="bgEjecutiva"></div>
              ) : sala === "Estudio de Podcast" ? (
                <div key="bgCabina" className="bgCabina"></div>
              ) : sala === "Hall" ? (
                <div key="bgHall" className="bgHall"></div>
              ) : sala === "Estudio" ? (
                <div key="bgVideo" className="bgVideo"></div>
              ) : sala === "Presidencia" ? (
                <div key="bgPresi" className="bgPresi"></div>
              ) : (
                <div key="bgDefault" className="bgVip"></div>
              )}
              {/* fin seleccion de salas*/}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Reservation;
